import { DataBean } from "../DataBean";

export class ProductionOrderToFinishedProduct extends DataBean {

    public async getProductionOrderToFinishedProductCatalog(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderRemissionCatalogByProductionOrder_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }

}